// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".case-detail-view .service-case-node{display:flex;justify-content:space-between}.case-detail-view .service-case-node .detail-status__description{margin:0}.case-detail-view .service-case-detail-form .form-group.inline .control-label{flex:none;margin:0;text-align:left;width:150px}.case-detail-view .service-case-detail-form .content-container{min-height:140px}", ""]);
// Exports
module.exports = exports;
